import { render, staticRenderFns } from "./GeneralHeader.vue?vue&type=template&id=93bfff8c&scoped=true&"
import script from "./GeneralHeader.vue?vue&type=script&lang=js&"
export * from "./GeneralHeader.vue?vue&type=script&lang=js&"
import style0 from "./GeneralHeader.vue?vue&type=style&index=0&id=93bfff8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93bfff8c",
  null
  
)

export default component.exports